<template>
  <b-modal
    ref="modal"
    :size="data.size || 'md'"
    :centered="data.centered || false"
    :scrollable="data.scrollable || false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :title-html="_trans('Set customer permissions')"
    :ok-only="true"
    :ok-title="_trans('Ok')"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="close(1)"
  >
    <div v-if="!permissions && !error" class="d-flex">
      <circle-loader class="m-auto" size="xs"></circle-loader>
    </div>
    <p v-else-if="!permissions && error" class="text-danger" v-text="error"></p>

    <ul class="list-unstyled" v-else>
      <li v-for="perm in permissions">
        <label>
          <input type="checkbox" v-model="perm.IsGiven" >
          <i v-text="getLabelByLang(perm.PermissionText)"></i>
        </label>
      </li>
    </ul>

    <template v-slot:modal-footer>
      <a
        class="text-primary mr-auto"
        style="line-height: 34px;"
        :href="permissionsUrl"
        target="_blank"
        v-html="_trans('Read more about privacy')"
      ></a>

      <button type="button" v-if="!permissions" class="btn btn-sm btn-info" :disabled="!canSkip" @click="skipPermissions()" v-html="_trans('Skip this operation')"></button>
      <button type="button" class="btn btn-sm btn-primary" :disabled="!permissions" v-html="_trans('Create new project')" @click="confirm()"></button>
    </template>
  </b-modal>
</template>
<script>
import { NextApiClient } from '@3cad/nextcore';
import { bus } from "@store/dau";
import modal from "@dialogs/modal.vue";

export default {
    mixins: [modal],
    components: {
        CircleLoader: () => import("@configurator/comp/circleLoader")
    },
    data() {
        return {
            canSkip: false,
            permissions: null,
            timeOut: null,
            error: null
        }
    },
    computed: {
        chain() {
            return this.data.chainId;
        },

        preferences() {
            return this.$store.getters['getPreferences'];
        },
        identityId() {
            if(!this.data.customer || !this.data.customer.IdentityId) {
                return null;
            }
            else
                return this.data.customer.IdentityId;
        },
        dialCode() {
            if(!this.chain)
                return null;
            else
                return this.chainsData.filter( r => { return r.id === this.chain })[0].dialCode;
        },
        permissionsUrl() {
            if(!this.chain)
                return null;
            else
                return this.chainsData.filter( r => { return r.id === this.chain })[0].permissionsUrl;
        },
        canSubmit() {
            return this.cod;
        }
    },
    watch: {
        permissions: function (newVal) {
            if(newVal !== null)
                clearTimeout(this.timeOut);
        }
    },
    methods: {
        getLabelByLang(permissionLabel) {
            let message;
            switch (this.user.userLang.toLowerCase()){
                case 'se':
                    message = permissionLabel.se ? permissionLabel.se : permissionLabel.en;
                    break;
                case 'no':
                    message = permissionLabel.no ? permissionLabel.no : permissionLabel.en;
                    break;
                case 'dk':
                    message = permissionLabel.dk ? permissionLabel.dk : permissionLabel.en;
                    break;
                case 'fi':
                    message = permissionLabel.fi ? permissionLabel.fi : permissionLabel.en;
                    break;
                default:
                    if(permissionLabel.en)
                        message = permissionLabel.en;
                    else{
                        for(let k in permissionLabel)
                            message = permissionLabel[k];
                    }
                    break;
            }

            if(!message){
                for(let k in permissionLabel)
                    message = permissionLabel[k];
            }
            return message;
        },
        /** Close modal dialog after save and/or update customer
         *
         */
        confirm() {
            bus.$emit('startLoading');

            let sendData = {
                Chain: this.chain,
                IdentityId: this.identityId,
                StoreNumber: this.user.shop.cod,
                SellerId: this.user.userId,
                CustomerDetails: {
                    FullName: this.data.customer.FirstName +' '+ this.data.customer.LastName,
                    Email: this.data.customer.Email,
                    Phone: (this.dialCode + this.data.customer.MobileNumber).replace(/\s/g, ''),
                    PostalAddress: '',
                    PostalCode: this.data.customer.Address.PostalCode,
                    PostalArea: this.data.customer.Address.PostalArea
                },
                Permissions: []
            };


            let permissions = this.permissions;
            for(let i=0; i<permissions.length; i++){
                sendData.Permissions.push({
                    Id: permissions[i].Id,
                    IsGiven: permissions[i].IsGiven,
                    Version: permissions[i].Version
                });
            }

            NextApiClient.combase(
                this.preferences.config.mediation,
                "ElWeb",
                'SetCustomerPermissions',
                { _UID: NextApiClient.getUID(), nextbe: NextApiClient.backSite, data: JSON.stringify(sendData),endpoint: this.preferences.config.extServices.customerSrv },
                json => {
                    if(json.Status !== 'OK'){
                        console.error(json);
                    }
                    this.response = json;
                    bus.$emit('stopLoading');
                    this.close(1);
                },
                err => {
                    this.response = err;
                    bus.$emit('stopLoading');
                    this.close(0);
                }
            )
        },
        skipPermissions() {
            this.response = null;
            this.close(1);
        },
        onShow() {
            this.permissions = null;
            this.error = null;
            this.timeOut = setTimeout( () => {
                this.canSkip = true;
            }, 10 * 1000);

            NextApiClient.combase(
                this.preferences.config.mediation,
                "ElWeb",
                'GetCustomerPermissions',
                {
                    _UID: NextApiClient.getUID(),
                    nextbe: NextApiClient.backSite,
                    data: JSON.stringify({Chain: this.chain, IdentityId: this.identityId}),
                    endpoint: this.preferences.config.extServices.customerSrv
                },
                json => {
                    if(json.Status !== 'OK'){
                        console.error(json);
                        this.error = json.Messages.pop();
                        return;
                    }

                    this.permissions = json.Permissions;
                });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/custom/epoq/dialogs/modalSetPermissions.vue